import Home from '@/views/Home.vue';
import SiteLocked from '@/views/SiteLocked.vue';

export default [
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404',
    },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/null',
    redirect: {
      path: '/',
    },
  },
  {
    path: '/404',
    name: '404',
    meta: {
      public: true,
    },
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    meta: {
      public: true,
    },
    component: () => import('@/views/Forbidden.vue'),
  },
  {
    path: '/error',
    name: 'error',
    meta: {
      public: true,
    },
    component: () => import('@/views/Error.vue'),
  },
  {
    path: '/lock',
    name: 'lock',
    meta: {
      public: true,
    },
    component: SiteLocked,
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About.vue'),
  },
  {
    path: '/profile/:id?',
    name: 'profile',
    component: () => import('@/views/Profile.vue'),
  },
  {
    path: '/employee/:id',
    name: 'employee',
    component: () => import('@/views/EmployeeDetail.vue'),
  },
  {
    path: '/user-profile',
    name: 'user-profile',
    component: () => import('@/views/UserProfile.vue'),
  },
  {
    path: '/attendance/:id?',
    name: 'attendance',
    component: () => import('@/views/Attendance.vue'),
  },

  {
    path: '/timesheet/:id?',
    name: 'timesheet',
    component: () => import('@/views/timesheet.vue'),
  },

  {
    path: '/upcoming-birthdays',
    name: 'upcoming-birthdays',
    component: () => import('@/views/UpcomingBirthdays.vue'),
  },
  {
    path: '/new-joinees',
    name: 'new-joinees',
    component: () => import('@/views/NewJoinees.vue'),
  },
  {
    path: '/policies',
    name: 'policies',
    component: () => import('@/views/Policies.vue'),
  },

  {
    path: '/hearmeout',
    name: 'hearmeout',
    component: () => import('@/views/hearmeout.vue'),
  },

  {
    path: '/employee-conversation',
    name: 'employee-conversation',
    component: () => import('@/views/LMS/Employeeconversation.vue'),
  }
  ,

  {
    path: '/lms',
    name: 'training-plan',
    component: () => import('@/views/LMS/Trainingplan.vue'),
  }
  ,

  // {
  //   path: '/training-plan',
  //   name: 'training-plan',
  //   component: () => import('@/views/LMS/Trainingplan.vue'),
  // }
  // ,
  {
    path: '/assigned-courses-new',
    name: 'assigned-courses-new',
    component: () => import('@/views/LMS/Assignedcoursenew.vue'),
  }
  ,
  {
    path: '/assigned-courses-new/:id?',
    name: 'assigned-courses-news',
    component: () => import('@/views/LMS/Assignedcoursenew.vue'),
  }
  ,
  {
    path: '/assigned-courses-byhr/:id?',
    name: 'assigned-courses-byhr',
    component: () => import('@/views/LMS/overalllmslist.vue'),
  }
  ,
  {
    path: '/goalsettings-byhr/:id?',
    name: 'goalsettings-byhr',
    component: () => import('@/views/pms/ByhrGoalsettings.vue'),
  }
  ,

  {
    path: '/assesmentview-byhr/:id?',
    name: 'assesmentview-byhr',
    component: () => import('@/views/pms/ByhrAssesmentsettings.vue'),
  }
  ,


  {
    path: '/org-chart',
    name: 'org-chart',
    component: () => import('@/views/OrgChart.vue'),
  },
  {
    path: '/regularization-review',
    name: 'regularization-review',
    component: () => import('@/views/RegularizationReview.vue'),
  },
  {
    path: '/performance-appraisal/:id?',
    name: 'performance-appraisal',
    component: () => import('@/views/pms/PerformanceAppraisal.vue'),
  },
  {
    path: '/okr/:id?',
    name: 'goal-settings',
    component: () => import('@/views/pms/Goalsettings.vue'),
  },

  {
    path: '/reviewer-assesment',
    name: 'reviewer-assesment',
    component: () => import('@/views/pms/ReviewerAssesment.vue'),
  },

  {
    path: '/wow-assesment/:id?',
    name: 'wow-assesment',
    component: () => import('@/views/pms/wowAssesment.vue'),
  },


  {
    path: '/assesmentgoalsetting/:id?',
    name: 'assesmentgoalsetting',
    component: () => import('@/views/pms/EmpQuarterlyReviewGoalsettings.vue'),
  }
  ,

  {
    path: '/empnewjoinform',
    name: 'empnewjoinform',
    component: () => import('@/views/pms/EmpNewjoinForm.vue'),
  },

  {
    path: '/empnewjoinformmanager',
    name: 'empnewjoinformmanager',
    component: () => import('@/views/pms/EmpNewjoinFormmanager.vue'),
  },

  {
    path: '/overallempnewjoinform',
    name: 'overallempnewjoinform',
    component: () => import('@/views/pms/Overallempnewjoinform.vue'),
  },

  {
    path: '/employee-quartely-review/:id?',
    name: 'employee-quartely-review',
    component: () => import('@/views/pms/EmpQuarterlyReviewGoalsettings.vue'),
  },

  {
    path: '/manager-goal-settings-teamapprove/:id?',
    name: 'manager-goal-settings-teamapprove',
    component: () => import('@/views/pms/ManagerApproveGoalsettings.vue'),
  },

  {
    path: '/assesment-manager-teamapprove/:id?',
    name: 'assesment-manager-teamapprove',
    component: () => import('@/views/pms/AssesmentManagerApproveGoalsettings.vue'),
  },

  {
    path: '/manager-view-lms/:id?',
    name: 'manager-view-lms',
    component: () => import('@/views/LMS/ManagerApprovelms.vue'),
  },

  {
    path: '/fill-goal-settings/:id?',
    name: 'goal-settingss',
    component: () => import('@/views/pms/FillGoalsettingsdata.vue'),
  },

  {
    path: '/assesment-fill-goal-settings/:id?',
    name: 'assesment-goal-settingss',
    component: () => import('@/views/pms/EmpQuarterlyReviewFillGoalsettings.vue'),
  },

  {
    path: '/manager-approve-goal-settings/:id?',
    name: 'manager-goal-settings-teamapprove',
    component: () => import('@/views/pms/ManagerFillGoalsettingsdata.vue'),
  },

  {
    path: '/assesment-manager-approve-goal-settings/:id?',
    name: 'manager-goal-settings-teamapprove',
    component: () => import('@/views/pms/ManagerFillassesmentGoalsettingsdata.vue'),
  },
  {
    path: '/assesment-manager-approve-employe-view/:id?',
    name: 'manager-goal-settings-teamapprove',
    component: () => import('@/views/pms/ManagerFillassesmentEmployeeview.vue'),
  },

  {
    path: '/reviewer-final-rating-review/:id?',
    name: 'reviewer-final-rating-review',
    component: () => import('@/views/pms/Reviewerfillratingandreview.vue'),
  },

  {
    path: '/wow-manager-approve/',
    name: 'wow-manager-approve',
    component: () => import('@/views/pms/WowManagerApprove.vue'),
  },

  {
    path: '/bulk-sms',
    name: 'bulk-sms',
    component: () => import('@/views/onboarding-and-it/BulkSms.vue'),
  },
  {
    path: '/call-quality-report',
    name: 'call-quality-report',
    component: () => import('@/views/pms/CallQualityReport.vue'),
  },
  {
    path: '/pms-reports',
    name: 'pms-reports',
    component: () => import('@/views/pms/PmsReports.vue'),
  },
  {
    path: '/performance-appraisal-manager-review',
    name: 'performance-appraisal-manager-review',
    component: () => import('@/views/pms/ManagerReview.vue'),
  },
  {
    path: '/performance-appraisal-reviewer-review',
    name: 'performance-appraisal-reviewer-review',
    component: () => import('@/views/pms/ReviewerReview.vue'),
  },
  {
    path: '/wow-awards',
    name: 'wow-awards',
    component: () => import('@/views/WowAwards.vue'),
  },
  {
    path: '/portal-support',
    name: 'portal-support',
    component: () => import('@/views/PortalSupport.vue'),
  },
  {
    path: '/leave-review',
    name: 'leave-review',
    component: () => import('@/views/LeaveReview.vue'),
  },
  {
    path: '/release-history',
    name: 'release-history',
    component: () => import('@/views/ReleaseHistory.vue'),
  },
  {
    path: '/biometric-logs/:id?',
    name: 'biometric-logs',
    component: () => import('@/views/BiometricLogs.vue'),
  },
  {
    path: '/leave-balance',
    name: 'leave-balance',
    component: () => import('@/views/LeaveBalance.vue'),
  },
  {
    path: '/email-creation',
    name: 'email-creation',
    component: () => import('@/views/EmailCreation.vue'),
  },
  {
    path: '/biometric-creation',
    name: 'biometric-creation',
    component: () => import('@/views/BiometricCreation.vue'),
  },
  {
    path: '/holidays',
    meta: {
      breadcrumb: true,
    },
    name: 'holiday',
    component: () => import('@/views/Holiday.vue'),
  },
  {
    path: '/hr-reports',
    name: 'hr-reports',
    component: () => import('@/views/HRReports.vue'),
  },
  {
    path: '/apply-leave',
    name: 'apply-leave',
    component: () => import('@/views/ApplyLeave.vue'),
  },
  {
    path: '/venus-access-request',
    name: 'venus-access-request',
    component: () => import('@/views/VenusAccessRequest.vue'),
  },
  {
    path: '/create-venus-access-request/:id',
    name: 'create-venus-access-request',
    component: () => import('@/views/CreateVenusAccessRequest.vue'),
  },
  {
    path: '/leave-history',
    name: 'leave-history',
    component: () => import('@/views/LeaveHistory.vue'),
  },
  {
    path: '/personal-details/:id?',
    name: 'personal-details',
    component: () => import('@/views/PersonalDetail.vue'),
  },
  {
    path: '/employee-conversation/:id?',
    name: 'employee-conversation',
    component: () => import('@/views/employeeconversation.vue'),
  },
  {
    path: '/probation-confirmation',
    name: 'probation-confirmation',
    component: () => import('@/views/ProbationConfirmation.vue'),
  },
  {
    path: '/manager-confirmation',
    name: 'manager-confirmation',
    component: () => import('@/views/ManagerConfirmation.vue'),
  },
  {
    path: '/leave-credit',
    name: 'leave-credit',
    component: () => import('@/views/LeaveCredit.vue'),
  },
  {
    path: '/overall-view',
    name: 'overall-view',
    component: () => import('@/views/pms/OverallPmsView.vue'),
  },

  {
    path: '/overall-quarterView',
    name: 'overall-QuarterView',
    component: () => import('@/views/pms/OverallquaterReview.vue'),
  },

  {
    path: '/quarterly-assesment',
    name: 'quarterly-assesment',
    component: () => import('@/views/pms/Overallquaterassesment.vue'),
  },


  {
    path: '/overall-lmsview/',
    name: 'overall-lmsview',
    component: () => import('@/views/LMS/OverallLmsView.vue'),
  },

  {
    path: '/payroll',
    name: 'payroll',
    component: () => import('@/views/Payroll.vue'),
  },
  {
    path: '/exit-manager-confirmation',
    name: 'exit-manager-confirmation',
    component: () => import('@/views/ExitFlow/ExitFlowManager.vue'),
  },
  {
    path: '/exit-admin-confirmation',
    name: 'exit-admin-confirmation',
    component: () => import('@/views/ExitFlow/ExitFlowAdmin.vue'),
  },
  {
    path: '/exit-finance-confirmation',
    name: 'exit-finance-confirmation',
    component: () => import('@/views/ExitFlow/ExitFlowFinance.vue'),
  },
  {
    path: '/exit-corporate-finance-confirmation',
    name: 'exit-corporate-finance-confirmation',
    component: () => import('@/views/ExitFlow/ExitFlowCRPFinance.vue'),
  },
  {
    path: '/exit-it-admin-confirmation',
    name: 'exit-it-admin-confirmation',
    component: () => import('@/views/ExitFlow/ExitFlowITAdmin.vue'),
  },
  {
    path: '/exit-hr-confirmation',
    name: 'exit-hr-confirmation',
    component: () => import('@/views/ExitFlow/ExitFlowHR.vue'),
  },
  {
    path: '/exit-confirmation',
    name: 'exit-confirmation',
    component: () => import('@/views/ExitFlow/ExitConfirmation.vue'),
  },
  {
    path: '/key-hire/v1',
    name: 'key-hire',
    component: () => import('@/views/AddKeyHire.vue'),
  },
  {
    path: '/upload-image',
    name: 'upload-image',
    component: () => import('@/views/UploadImage.vue'),
  },
  {
    path: '/ip-address',
    name: 'ip-address',
    component: () => import('@/views/IpAddress.vue'),
  },
  {
    path: '/send-sms',
    name: 'send-sms',
    component: () => import('@/views/onboarding-and-it/SendSMS.vue'),
  },
  {
    path: '/scl',
    name: 'scl',
    component: () => import('@/views/Scl.vue'),
  },
  {
    path: '/Sclcarrom',
    name: 'Sclcarrom',
    component: () => import('@/views/Sclcarrom.vue'),
  },
  {
    path: '/NewJoineeform',
    name: 'NewJoineeform',
    component: () => import('@/views/NewJoineeform.vue'),
  },
  {
    path: '/NewJoineeformsixty',
    name: 'NewJoineeform',
    component: () => import('@/views/NewJoineeformuptosixty.vue'),
  },
  {
    path: '/NewJoineeformmanager/:id?',
    name: 'NewJoineeform',
    component: () => import('@/views/NewJoineeformmanager.vue'),
  },
  {
    path: '/NewJoineeformmanagersixty/:id?',
    name: 'NewJoineeform',
    component: () => import('@/views/NewJoineeformmanagersixty.vue'),
  },
  {
    path: '/overallnewjoinformone/:id?',
    name: 'NewJoineeform',
    component: () => import('@/views/Overallnewjoinformone.vue'),
  },
  {
    path: '/overallnewjoinformtwo/:id?',
    name: 'NewJoineeform',
    component: () => import('@/views/Overallnewjoinformtwo.vue'),
  },


  {
    path: '/add-division',
    name: 'add-division',
    component: () => import('@/views/AddDivision.vue'),
  },
  {
    path: '/pay-slip',
    name: 'pay-slip',
    component: () => import('@/views/PaySlip.vue'),
  },
  {
    path: '/add-pay-slip',
    name: 'add-pay-slip',
    component: () => import('@/views/AddPaySlip.vue'),
  },
  {
    path: '/trigger-mail',
    name: 'trigger-mail',
    component: () => import('@/views/TriggerMail.vue'),
  },
  {
    path: '/onboarding/:id?',
    name: 'onboarding',
    component: () => import('@/views/onboarding-and-it/Onboarding.vue'),
  },
  {
    path: '/exit-interview',
    name: 'exit-interview',
    component: () => import('@/views/ExitFlow/ExitRating.vue'),
  },
  {
    path: '/download-sheet',
    name: 'download-sheet',
    component: () => import('@/views/ExitFlow/DownloadSheet.vue'),
  },
  {
    path: '/shift-check',
    name: 'shift-check',
    component: () => import('@/views/ShiftCheck.vue'),
  },
  {
    path: '/rms',
    name: 'rms',
    component: () => import('@/views/RMS/Rms.vue'),
  },
  {
    path: '/offer-release',
    name: 'offer-release',
    component: () => import('@/views/RMS/OfferRelease.vue'),
  },
  {
    path: '/survey-question',
    name: 'survey-question',
    component: () => import('@/views/SurveyQuestion.vue'),
  },
  {
    path: '/create-resume',
    name: 'create-resume',
    component: () => import('@/views/RMS/CreateResumeId.vue'),
  },
  {
    path: '/history-of-leave',
    name: 'history-of-leave',
    component: () => import('@/views/HistoryOfLeave.vue'),
  },
  {
    path: '/edit-payroll-calendar',
    name: 'edit-payroll-calendar',
    component: () => import('@/views/EditPayrollCalendar.vue'),
  },
  {
    path: '/it-team',
    name: 'it-team',
    component: () => import('@/views/ItTeam.vue'),
  },
  {
    path: '/interview-process',
    name: 'interview-process',
    component: () => import('@/views/RMS/InterviewProcess.vue'),
  },
  {
    path: '/onboard-candidate/:id?',
    name: 'onboard-candidate',
    component: () => import('@/views/RMS/OnboardCandidate.vue'),
  },
  {
    path: '/accept-or-decline-offer',
    name: 'accept-or-decline-offer',
    component: () => import('@/views/RMS/AcceptOrDeclineOffer.vue'),
  },
  {
    path: '/unlock-pms',
    name: 'unlock-pms',
    component: () => import('@/views/pms/UnlockPms.vue'),
  },
  {
    path: '/remainder-mail',
    name: 'remainder-mail',
    component: () => import('@/views/pms/RemainderMail.vue'),
  },
  {
    path: '/user-management',
    name: 'user-management',
    component: () => import('@/views/UserManagement.vue'),
  },
  {
    path: '/graph',
    name: 'graph',
    component: () => import('@/views/pms/Graph.vue'),
  },
  {
    path: '/organization-chart',
    name: 'organization-chart',
    component: () => import('@/views/OrganizationChart.vue'),
  },
  {
    path: '/od-report',
    name: 'od-report',
    component: () => import('@/views/OdReport.vue'),
  },
  {
    path: '/document-submission',
    name: 'document-submission',
    component: () => import('@/views/FBCP/DocumentSubmission.vue'),
  },
  {
    path: '/download-document',
    name: 'download-document',
    component: () => import('@/views/FBCP/DownloadDocument.vue'),
  },
  {
    path: '/warning-letter',
    name: 'warning-letter',
    component: () => import('@/views/warning-letter/WarningLetter.vue'),
  },
  {
    path: '/relieving-letter',
    name: 'relieving-letter',
    component: () => import('@/views/warning-letter/RelievingLetter.vue'),
  },
  {
    path: '/laptop-screen',
    name: 'laptop-screen',
    component: () => import('@/views/onboarding-and-it/LaptopScreen.vue'),
  },
  {
    path: '/marriage-leave-report',
    name: 'marriage-leave-report',
    component: () => import('@/views/MarriageLeave.vue'),
  },
  {
    path: '/present-request',
    name: 'present-request',
    component: () => import('@/views/PresentRequest.vue'),
  },
  {
    path: '/employee-changes',
    name: 'employee-changes',
    component: () => import('@/views/EmployeeChanges.vue'),
  },
  {
    path: '/work-station-allotment',
    name: 'work-station-allotment',
    component: () => import('@/views/admin-team/LocationVerification.vue'),
  },
  {
    path: '/workstation-confirmation',
    name: 'workstation-confirmation',
    component: () => import('@/views/onboarding-and-it/WorkstationConfirmation.vue'),
  },
  {
    path: '/initiate-resignation/:id?',
    name: 'initiate-resignation',
    component: () => import('@/views/ExitFlow/InitiateResignation.vue'),
  },
  {
    path: '/confirmation-of-resignation',
    name: 'confirmation-of-resignation',
    component: () => import('@/views/ExitFlow/ManagerConfirmation.vue'),
  },
  {
    path: '/hr-confirmation',
    name: 'hr-confirmation',
    component: () => import('@/views/ExitFlow/HRConfirmation.vue'),
  },
  {
    path: '/business-head',
    name: 'business-head',
    component: () => import('@/views/BusinessHead.vue'),
  },
  {
    path: '/late-comers',
    name: 'late-comers',
    component: () => import('@/views/LateComers.vue'),
  },
  {
    path: '/domain-name',
    name: 'domain-name',
    component: () => import('@/views/DomainName.vue'),
  },
  {
    path: '/courses-available',
    name: 'courses-available',
    component: () => import('@/views/LMS/Lms.vue'),
  },
  {
    path: '/assigned-courses',
    name: 'assigned-courses',
    component: () => import('@/views/pms/AssignedCourses.vue'),
  }
  ,
  // {
  //   path: '/training-plan',
  //   name: 'training-plan',
  //   component: () => import('@/views/LMS/Trainingplan.vue'),
  // },
  {
    path: '/reviewer-page',
    name: 'reviewer-page',
    component: () => import('@/views/ExitFlow/ReviewerPage.vue'),
  },
  {
    path: '/upload-annual-holiday',
    name: 'upload-annual-holiday',
    component: () => import('@/views/AnnualHoliday.vue'),
  },
  {
    path: '/ijp',
    name: 'ijp',
    component: () => import('@/views/IJP/IJP.vue'),
  },
  {
    path: '/employee-leave',
    name: 'employee-leave',
    component: () => import('@/views/ReporteeLeaveDetail.vue'),
  },
  {
    path: '/reportees',
    name: 'reportees',
    component: () => import('@/views/BusinessHeadReportees.vue'),
  },
  {
    path: '/quartely-leave-report',
    name: 'quartely-leave-report',
    component: () => import('@/views/QuartelyLeaveReport.vue'),
  },
  {
    path: '/leave-cancel',
    name: 'leave-cancel',
    component: () => import('@/views/LeaveCancel.vue'),
  },
  {
    path: '/payroll-form',
    name: 'payroll-form',
    component: () => import('@/views/Payroll/Payroll.vue'),
  },
  {
    path: '/resignation-acceptance',
    name: 'resignation-accpetance',
    component: () => import('@/views/ExitFlow/ResignationAcceptance.vue'),
  },
  {
    path: '/payout-faqs',
    name: 'payout-faqs',
    component: () => import('@/views/Payroll/PayoutFaq.vue'),
  },
  {
    path: '/exit-process-document',
    name: 'exit-process-document',
    component: () => import('@/views/ExitFlow/ExitProcessDocument.vue'),
  },
  {
    path: '/coc-acceptance',
    name: 'coc-acceptance',
    component: () => import('@/views/Payroll/PayrollOptions.vue'),
  },
  // {
  //   path: '/insurance-details',
  //   name: 'insurance-details',
  //   component: () => import('@/views/Payroll/Insurance.vue'),
  // },

  {
    path: '/recovery-letter',
    name: 'recovery-letter',
    component: () => import('@/views/warning-letter/RecoveryLetter.vue'),
  },
  {
    path: '/joining-kit',
    name: 'joining-kit',
    component: () => import('@/views/onboarding-and-it/JoiningKit.vue'),
  },
  {
    path: '/uan-creation',
    name: 'uan-creation',
    component: () => import('@/views/Payroll/UANCreation.vue'),
  },
  {
    path: '/bank-account-creation',
    name: 'bank-account-creation',
    component: () => import('@/views/Payroll/BankAccountCreation.vue'),
  },
  {
    path: '/delete-exit-interview-sheet',
    name: 'delete-exit-interview-sheet',
    component: () => import('@/views/ExitFlow/DeleteExitSheet.vue')
  },
  {
    path: '/add-pms-cycle',
    name: 'add-pms-cycle',
    component: () => import('@/views/pms/AddPmsCycle.vue')
  },

  {
    path: '/add-quarterly-goalsetting-cycle',
    name: 'add-quarterly-goalsetting-cycle',
    component: () => import('@/views/pms/AddQuarterlyGoalsettingCycle.vue')
  },

  {
    path: '/address-approval',
    name: 'address-approval',
    component: () => import('@/views/AddressApproval.vue')
  },
  {
    path: '/send-exit-email',
    name: 'send-exit-email',
    component: () => import('@/views/ExitFlow/SendEmail.vue')
  },
  {
    path: '/inspire-engagement',
   name: 'inspire-engagement',
   beforeEnter() { window.open("https://mysulekharewards.xoxoday.com/", "_blank") },
   component: () => import('@/views/InspireEngagement/InspireEngagement.vue')
 },

  {
    path: '/approval-ie',
    name: 'approval-ie',
    component: () => import('@/views/InspireEngagement/Approval.vue')
  },
  {
    path: '/bulk-employee-updation',
    name: 'bulk-employee-updation',
    component: () => import('@/views/BulkEmployeeUpdation.vue')
  },
  {
    path: '/send-welcome-email',
    name: 'send-email',
    component: () => import('@/views/SendWelcomeEmail.vue'),
  },
  {
    path: '/promotion-letter',
    name: 'promotion-letter',
    component: () => import('@/views/PromotionLetter.vue')
  }
  // {
  // path: '/august-payout/:id?',
  // name: 'august-payout',
  // component: () => import('@/views/Payroll/BccPayout.vue'),
  // },
  // ,
];
